import { render, staticRenderFns } from "./TranscriptToc.vue?vue&type=template&id=a5b64822&lang=pug&"
import script from "./TranscriptToc.vue?vue&type=script&lang=js&"
export * from "./TranscriptToc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports